import { useQuery } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchApuracaoByIdProduct(id_product?: string) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['resume', id_product],
    queryFn: async () => {
      if (!id_product) throw new Error('ID do produto não fornecido')

      const response = await api.get(`/apuracao/${id_product}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data && response.data.data) {
        return response.data.data
      } else {
        throw new Error('Data não encontrado no resultado')
      }
    },
    enabled: Boolean(id_product)
  })
}
